import moment from 'moment';
import React from 'react';
import { IPatientDocument } from 'store/mobx/myHealthStore/myHealthStore.type';
import styled from 'styled-components';

import rtfToHtml from '@iarna/rtf-to-html';
import { useState, useEffect } from 'react';
import { useMyHealthStore } from 'store/mobx/mobx';

const Container = styled.div`
    height: 100%;
    padding: 0rem 2rem;
    padding-top: 1.5rem;
    width: 100%;
`
const Header = styled.div`
    display: flex;
    flex-direction:  column;
    margin-bottom: 1rem;
`
const Title = styled.div`
    font-size: 15px;
    font-weight: bold;
    padding-bottom: 0;
    text-decoration: underline;
    text-decoration-color: #DADADA;
`
const Result = styled.div`
    font-weight: 300;
    margin-bottom: 1rem;
`
const Line = styled.div`
    width: 100%;
    border-bottom: 1px solid #F0F0F0;
    margin: 1rem 0;
    margin-top: 0.5rem;
`
const DownloadLink = styled.a`
    font-size: var(--font-20);
    color: var(--color-pelorous);
    cursor: pointer;
`

interface IProps {
    item: IPatientDocument
}
const PatientDocumentsOpen: React.FC<IProps> = ({item}) => {
    const [val, setVal] = useState("");
    const isRTF = item.Content?.find(d => d.ContentType === "application/rtf" && d.Data.startsWith("{")) !== undefined;
    const rtfData = item.Content?.find(d => d.ContentType === "application/rtf")?.Data ?? "";
    const isPDF = item.Content?.find(d => d.ContentType === "application/pdf") !== undefined;
    
    const phrStore = useMyHealthStore();
  
    // Check if RTF format then convert to html, otherwise use the string given
    useEffect(()=>{
		if (isRTF) rtfToHtml.fromString(rtfData, (err: any, html: any) => { setVal(html) })
	});

    return (
        <Container>
            <Header>
                <Title>{item.Description} (Arrived on {moment(item.DateTime).format("DD/MM/YY")})</Title>
            </Header>
            <Result>
                {isRTF && <div dangerouslySetInnerHTML={{__html: val}} />}
                {isPDF && (<p><DownloadLink onClick={() => phrStore.downloadDocument(item.PatientId, item.Id)}>Click here to download document</DownloadLink></p>)}
            </Result>
            <Line style={{margin: "0"}}/>
        </Container>
    )
}

export default PatientDocumentsOpen;